import styled from '@emotion/styled';
import { Divider } from 'antd';
import { useTranslate } from '@tolgee/react';
import BubbleMessage from 'components/Dialogue/components/Message/BubbleMessage';
import { capitalize } from 'lodash-es';
import { memo } from 'react';

export interface NonsupportedMessageV2Props {
  dataSource: Conversation.Message;
}

const Bubble = styled(BubbleMessage)`
  padding: 0;
`;
const ContentUp = styled.div`
  padding: 8px 12px 0 12px;
`;
const ContentDown = styled(ContentUp)`
  padding: 0 12px 8px 12px;
  color: #84868c;
`;
const BubbleDivider = styled(Divider)`
  margin: 4px 0;
`;
const MESSAGE_TYPE_KEY_MAP: Record<string, string> = {
  IMAGE: 'domain.message.type.image',
  VIDEO: 'domain.message.type.video',
  STICKER: 'domain.message.type.sticker',
  ITEM: 'domain.message.type.product',
  FAQ_LIVEAGENT: 'domain.message.type.faqLiveAgent',
  VARIATION_CARD: 'domain.message.type.variationCard',
  SYS_ASSIGN: 'domain.message.systemType.assign',
  SYS_WA_REJECT: 'domain.message.systemType.whatsAppRejected',
  SYS_INIT_CONVERSATION: 'scene.chatWorkspace.messageThread.systemMessage.initiatedConversation',
  SYS_FAQ_QUESTION: 'scene.chatWorkspace.messageThread.systemMessage.faqQuestion',
  SHOPEE_RETURN_REFUND_CARD: 'scene.chatWorkspace.messageThread.systemMessage.shopeeReturnRefund',
  recall: 'scene.chatWorkspace.messageThread.systemMessage.recall',
};

const getMessageTypeKey = (type: string): string =>
  MESSAGE_TYPE_KEY_MAP[type] || 'scene.chatWorkspace.messageThread.feedback.unknownMessageType';

const NonsupportedMessageV2 = (props: NonsupportedMessageV2Props) => {
  const { dataSource } = props;
  const { t } = useTranslate();

  return (
    <Bubble>
      <ContentUp>[{t(getMessageTypeKey(dataSource.messageType))}]</ContentUp>
      <BubbleDivider />
      <ContentDown>
        {t('scene.chatWorkspace.messageThread.unsupported.viewOnPlatform', {
          platform: capitalize(dataSource.channel),
        })}
      </ContentDown>
    </Bubble>
  );
};
export default memo(NonsupportedMessageV2);
